import { FormHelperText, Tooltip } from "@mui/material";
import { Box } from "@mui/system";
import { unitFormsWithErrorsSelector } from "pages/UploadCertificate/state/uploadCertificateUnitState";
import * as React from "react";
import { useRecoilValue } from "recoil";
import ordinaryColors from "themes/ordinaryColors";
import Props from "./index.d";

const UnitErrorsOnCertificate: React.FC<Props> = (props) => {
  const unitErrors = useRecoilValue(unitFormsWithErrorsSelector);

  const {
    className,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    testId,
    errorManager,
    data: { setAndSave },
  } = props;

  const errorManagerRes = errorManager({
    errorJoiner: (errors) => {
      return errors.join(", ");
    },
  });

  React.useEffect(() => {
    const unitsErrorsSum = unitErrors.reduce<number>((acc, unit) => {
      return acc + unit.count;
    }, 0);

    setAndSave(unitsErrorsSum);
  }, [unitErrors, setAndSave]);

  if (errorManagerRes.error)
    return (
      <Box sx={{ margin: "0rem 0rem" }}>
        <FormHelperText
          className={className}
          sx={{
            color: ordinaryColors.error,
            fontSize: "16px",
            minHeight: `calc(20px * ${unitErrors.length})`,
            margin: "0.5rem 0rem",
          }}
        >
          {(errorManagerRes.helperText as string).split("\n").map((errorText, i) =>
            errorText.length < 80 ? (
              <div key={i} style={{ maxHeight: "24px", minHeight: "24px", overflow: "hidden" }}>
                {errorText.length < 80 ? errorText : errorText.substring(0, 70) + "..."}
              </div>
            ) : (
              <Tooltip key={i} title={errorText} placement="top" arrow>
                <div style={{ maxHeight: "24px", minHeight: "24px", overflow: "hidden" }}>
                  {errorText.substring(0, 70) + "..."}
                </div>
              </Tooltip>
            )
          )}
        </FormHelperText>
      </Box>
    );
  return null;
};

export default UnitErrorsOnCertificate;
